export const All = {
  subject: "all",
  actions: "manage"
};

export const RolePage = {
  subject: "role",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    delete: "delete"
  }
};

export const Staff = {
  subject: "staff",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    delete: "delete",
    export: "export"
  }
};
export const Student = {
  subject: "student",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    delete: "delete",
    exportStudent: "export-student",
    withdraw: "withdraw",
    viewTranscript: "view-transcript",
    exportTranscript: "export-transcript",
    viewCommunicationLog: "view-communication-log",
    editCommunicationLog: "edit-communication-log",
    deleteCommunicationLog: "delete-communication-log",
    exportGradebook: "export-grade-book"
  }
};

export const Subject = {
  subject: "subject",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    delete: "delete"
  }
};

export const GraduationCategory = {
  subject: "graduation-category",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    delete: "delete"
  }
};

export const Program = {
  subject: "program",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view"
  }
};

export const GradeScale = {
  subject: "grade-scale",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view"
  }
};

export const Term = {
  subject: "term",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    copy: "copy",
    delete: "delete",
    conclude: "conclude"
  }
};

export const Class = {
  subject: "class",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    copy: "copy",
    delete: "delete",
    conclude: "conclude"
  }
};

export const Calendar = {
  subject: "calendar",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    copy: "copy",
    delete: "delete",
    conclude: "conclude",
    // uploadVcr: "upload-vcr"
  }
};

export const Communication = {
  subject: "communication",
  actions: {
    sendMail: "send-mail",
    template: "management-template",
    sendAnnouncement: "send-announcement",
    sendSms: "list-sms"
  }
};

export const Attendance = {
  subject: "attendance",
  actions: {
    list: "list",
    import: "import",
    edit: "edit",
    view: "view"
  }
};

export const Report = {
  subject: "report",
  actions: {
    view: "view"
  }
};

export const ScoreReport = {
  subject: "score-report",
  actions: {
    view: "view"
  }
};

export const AttendanceReport = {
  subject: "attendance-report",
  actions: {
    view: "view"
  }
};

export const GraduationStudents = {
  subject: "graduation-students",
  actions: {
    list: "list",
    graduation: "graduation"
  }
};

export const IndividualAssessment = {
  subject: "individual-assessment",
  actions: {
    view: "view",
    import: "import"
  }
};
export const CommunicationLog = {
  subject: "communication-log",
  actions: {
    view: "view"
  }
};
export const OverallAssessment = {
  subject: "overall-assessment",
  actions: {
    view: "view"
  }
};

export const ExtendedExportation = {
  subject: "extended-exportation",
  actions: {
    export: "export"
  }
};

export const Enrollment = {
  subject: "enrollment",
  actions: {
    edit: "edit",
    delete: "delete",
    add: "add"
  }
};
export const Behavior = {
  subject: "behavior",
  actions: {
    edit: "edit",
    delete: "delete",
    add: "add"
  }
};
export const ProgressReport = {
  subject: "progress-Report",
  actions: {
    setting: "progress_setting",
    totalReport: "progress_total_report",
    submittedReport: "progress_submitted_report",
    censorSubmittedReport: "progress_censor_submitted_report"
  }
};
export const Survey = {
  subject: "survey",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    copy: "copy",
    delete: "delete",
    report: "report",
    sendMail: "send_mail"
  }
};

export const TaskManagement = {
  subject: "task-management",
  actions: {
    allList: "all-list",
    reportedByMe: "reported-by-me",
    reviewedByMe: "reviewed-by-me",
    ownedByMe: "owned-by-me",
    reportChart: "report",
    add: "add"
  }
};

export const ZoomMeeting = {
  subject: "zoom-meeting",
  actions: {
    list: "list",
    add: "add",
    edit: "edit",
    view: "view",
    delete: "delete",
    report: "report",
    updateReport: "update-report"
  }
};
